import styled from "styled-components";
import bannerImage from "../../assets/images/home/velo_color_2x.webp";
import bannerMobileImage from "../../assets/images/home/velo_color_mobile_2x.webp";
import { useNavigation } from "../../utils/navigation";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 42px;
`;

const Wrapper = styled.div`
  margin: var(--spacing-xxl) 0;
  width: 100%;
  min-height: 70vh;

  background-image: url(${bannerMobileImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;

  display: flex;
  align-items: flex-end;
  box-sizing: border-box;
  @media (min-width: 1025px) {
    width: 100%;
    max-width: var(--max-width-container);
  }
  @media (min-width: 765px) {
    background-image: url(${bannerImage});
    min-height: 340px;
    border: 1px solid rgb(171, 201, 223);
    background-position: center;
    align-items: center;
  }
`;
const TextContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 40px;
  height: 90%;

  flex-direction: column;
  text-align: center;

  @media (min-width: 768px) and (max-width: 1040px) {
    height: 90%;
    align-items: center;
  }
  @media (min-width: 765px) {
    flex-direction: row;
    height: 100%;
    text-align: left;
    width: 90%;
  }
`;
const Title = styled.h2`
  font-size: var(--font-size-xlarge);
  font-weight: 400;
  margin: var(--spacing-lg) 0 var(--spacing-md) 0;
  text-transform: uppercase;
  max-width: 100%;
  @media (min-width: 765px) {
    font-size: var(--font-size-xxlarge);
  }
  color: black;
`;
const Text = styled.p`
  font-size: var(--font-size-base);
  margin-bottom: 14px;

  @media (min-width: 765px) {
    font-size: var(--font-size-base);
    max-width: 65%;
  }
`;
const Subtitle = styled.h4`
  font-weight: 700;
  font-size: var(--font-size-base);
  opacity: 0.5;
  color: black;
`;
const Button = styled.button`
  white-space: nowrap;
  margin: 0 auto;
  padding: 14px 20px;
  text-transform: uppercase;
`;
const BannerHorizontal = () => {
  const { t } = useTranslation();
  const { goToShop } = useNavigation();
  const navigate = useNavigate();
  return (
    <Container>
      <Wrapper>
        <TextContainer>
          <div style={{ padding: "14px 0" }}>
            <Subtitle>{t("HOME.BANNER_SUBTITLE")}</Subtitle>
            <Title>{t("HOME.BANNER_TITLE")}</Title>
            <Text>{t("HOME.BANNER_TEXT")}</Text>
            <Button
              className="button-transparent"
              onClick={() => navigate(goToShop())}
            >
              {t("BUTTONS.SHOP_NOW")}
            </Button>
          </div>
        </TextContainer>
      </Wrapper>
    </Container>
  );
};

export default BannerHorizontal;
